import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Dashboard son eklenen formlar bölümü
 */
const RecentFormsSection = ({ forms }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!forms || forms.length === 0) {
    return null;
  }

  return (
    <Box className="recent-forms">
      <Typography className="stats-title" sx={{ mb: 3 }}>
        Son Eklenen Formlar
      </Typography>
      <Grid container spacing={3}>
        {forms.slice(0, 4).map((form, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper 
              className="form-card"
              elevation={0}
              onClick={() => navigate(`/forms/${form.id}`)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography className="form-title">
                {form.name || 'İsimsiz Form'}
              </Typography>
              <Typography className="form-description">
                {form.description || 'Açıklama yok'}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography className={`form-status ${form.isPublished ? 'status-published' : 'status-draft'}`}>
                  {form.isPublished ? 'Yayında' : 'Taslak'}
                </Typography>
                <Typography className="form-responses">
                  {form.responses?.length || 0} yanıt
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RecentFormsSection;
